import { ViewerModule } from '@g.frame/core';
import { Color, Vector2 } from 'three';
import { FONT } from '@g.frame/common.loaders';
import { TextComponent } from '@g.frame/components.text';
const styleConfig = {
    color: new Color('#FFFFFF'),
    background: new Color('#432A1C'),
};
export default class HeaderTextElement extends ViewerModule {
    constructor(loader, textComponentFactory) {
        super();
        this.loader = loader;
        this.textComponentFactory = textComponentFactory;
        this.loader.addResources([
            {
                name: 'Ubuntu&ttf-700-normal',
                url: require('../../assets/Ubuntu-Bold.ttf'),
                type: FONT
            },
        ]);
        this.uiObject.name = 'HeaderText';
    }
    set(newOptions) {
        if (newOptions) {
            this.oldOptions = this.options;
            this.options = newOptions;
        }
        this.headerText && this.disposeObject(this.headerText);
        this.resultSize = this.options.window.size.clone().multiplyScalar(this.options.window.scale);
        this.initText();
    }
    initText() {
        const headerSize = this.resultSize.clone();
        this.addObject(this.headerText = this.textComponentFactory.getFactory(TextComponent)({
            size: headerSize,
            pxSize: new Vector2(256 * headerSize.x / headerSize.y * this.options.window.pxScale, 256 * this.options.window.pxScale),
            text: {
                value: this.options.text,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'Ubuntu',
                    weight: '700',
                    size: '200px',
                    color: styleConfig.color.getStyle()
                },
                margin: 0.001,
                lineHeight: 229.9,
            },
            background: {
                color: styleConfig.background.getStyle()
                // color: 'transparent'
            }
        }));
    }
}
